<network-home *ngIf="isLogin; else islogout"></network-home>

<ng-template #islogout>
  <del-shared-homepage></del-shared-homepage>
</ng-template>


